"use client";

function stripSqlComments(sql: string) {
  return sql.replace(/\/\*[\s\S]*?\*\//g, " ").replace(/--[^\r\n]*/g, " ");
}

function stripSqlStrings(sql: string) {
  return sql
    .replace(/'(?:''|[^'])*'/g, "''")
    .replace(/"(?:\"\"|[^"])*"/g, '""')
    .replace(/`[^`]*`/g, "``")
    .replace(/\[[^\]]*\]/g, "[]");
}

export function isReadOnlySql(sql: string) {
  const withoutComments = stripSqlComments(sql).trim();
  const normalized = stripSqlStrings(withoutComments)
    .replace(/;+\s*$/g, "")
    .toLowerCase();

  if (!normalized) return false;
  if (!/^(select|with|explain)\b/.test(normalized)) return false;
  if (normalized.includes(";")) return false;

  return !/\b(insert|update|delete|drop|alter|create|replace|truncate|attach|detach|vacuum|reindex|pragma|grant|revoke|set|call|execute|merge)\b/.test(
    normalized,
  );
}

export function withReadLimit(sql: string, limit: number) {
  const trimmed = sql.trim().replace(/;+\s*$/g, "");
  const normalized = stripSqlComments(trimmed).trim();

  if (/^explain\b/i.test(normalized)) return trimmed;

  return `SELECT * FROM (${trimmed}) AS voice_query LIMIT ${limit}`;
}
